const cisAxiosConfig = {
  headers: {
    accept: 'application/familysearch-identity-result+v4.1+json',
    'content-type': 'application/familysearch-identity-result+v4.1+json',
  },
}

export default cisAxiosConfig
